import { Component, OnInit } from '@angular/core';
import {TranslateService} from "../../../services/translate.service";


export interface CardsContent {
  title: string,
  date: string,
  avatar: string,
  alink: string,
  images: string [],
  text: string [],
  links:  string []
}

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {

  allNewsEng: CardsContent [] = [
    {
      title: 'Under development mode',
      date: 'in progress',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'This site is the new version of official site of AHM. Some features under development mode.',
          'Almost all modules and psy modeler moved to new technologies. Some stages are beta and release candidates. Other hidden or marked special.',
          'If you need AHM tools faster. Simply power-up the process in the section - Donate.'],
      links: []
    },
    {
      title: 'AHM 2 now available worldwide',
      date: 'Middle of Summer 2020',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Alphabet of the Human Mind — 2: Global Psychotherapy now available worldwide for purchasing.',
          'Core AHM classification has been translating for a very long time and now works same well as in primary language.',
          'Very accurate, effective, and powerful.'
      ],
      links: ['https://www.amazon.com/dp/B08CZQBP3S']
    },
    {
      title: 'The long-awaited AHM 2.1',
      date: 'Beginning of Winter 2020',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'The long-awaited version 2.1 of the AHM series has been released in russian language.',
          'AHM2: global psychotherapy. This version did not include psychological reviews of films and games, which occupied approximately the same amount as the content of AHM 2.1.',
          'You can buy in several ways. Order on the site. In online stores.'],
      links: ['https://www.ozon.ru/context/detail/id/169547583/']
    },
    {
      title: 'AHM1 in Bookvoed',
      date: '10.04.2019',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Book AHM1 can be purchased in the largest book network of Russia Bookvoed!'],
      links: ['https://www.bookvoed.ru/']
    },
    {
      title: 'AHM1 in Book House Spb',
      date: '22.03.2018',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Book AHM1 can be purchased at the "Book House Spb" bookstore! Top1 Saint Petersburg\'s books shop in the center of the city.'],
      links: ['https://www.spbdk.ru/']
    },
    {
      title: 'AHM1 in Non/fiction 2017',
      date: '28.11.2017',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Non/fiction 2017, Russia, Moscow! AHM1 is presented at this international event.'
      ],
      links: []
    },
    {
      title: 'The first news!',
      date: '18.10.2017',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'First news added! The "News" section on the official website of the AHM has been created!',
          'Commentary: This news was created on the last site of the AHM.'
      ],
      links: []
    }
  ];

  allNewsRus: CardsContent [] = [
    {
      title: 'В режиме разработки',
      date: 'в процессе',
      avatar: '',
      alink: '',
      images: [],
      text: [
        'Этот сайт является новой версией официального сайта АЧП. Некоторые функции в режиме разработки.',
        'Практически все модули и Psy Modeler перешли на новые технологии. Некоторые этапы - это бета-версия и релиз-кандидаты. Другие скрытые или отмеченные специально.',
        'Если вам нужны инструменты АЧП быстрее. Можно легко ускорить процессы в разделе - Поддержать проект.'],
      links: []
    },
    {
      title: 'Книга АЧП2 на английском теперь доступна по всему миру',
      date: 'Середина лета 2020',
      avatar: '',
      alink: '',
      images: [],
      text: [
        'Азбука Человеческой Психики - 2: глобальная психотерапия теперь доступна по всему миру для покупки.',
        'Базовая классификация АЧП переводилась очень долго и теперь работает также хорошо, как на основном языке, - русском.',
        'Очень точно, эффективно и мощно.'
      ],
      links: ['https://www.amazon.com/dp/B08CZQBP3S']
    },
    {
      title: 'Долгожданная АЧП 2.1',
      date: 'Начало Зимы 2020',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Вышла долгожданная версия 2.1 серии АЧП.',
          'АЧП2: глобальная психотерапия. В эту версию не вошли психологические рецензии к фильмам и играм, которые занимали примерно столько же, сколько само содержание АПЧ2.1.',
          'Купить можно несколькими способами. Заказ на сайте. В интернет магазинах.'
      ],
      links: ['https://www.ozon.ru/context/detail/id/169547583/']
    },
    {
      title: 'АЧП1 в Буквоеде',
      date: '10.04.2019',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Книгу АЧП1 можно приобрести в крупнейшей книжной сети России Буквоед!'
      ],
      links: ['https://www.bookvoed.ru/']
    },
    {
      title: 'АЧП1 в Доме Книги',
      date: '22.03.2018',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Книгу АЧП1 можно приобрести в книжном магазине \'Дом Книги\'!'
      ],
      links: ['https://www.spbdk.ru/']
    },
    {
      title: 'АЧП1 на Non/fiction 2017',
      date: '28.11.2017',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Non/fiction 2017, Russia, Moscow! АЧП1 презентуется на международном событии.'
      ],
      links: []
    },
    {
      title: 'Первая новость!',
      date: '18.10.2017',
      avatar: '',
      alink: '',
      images: [],
      text: [
          'Добавлена первая новость! Раздел "Новости" на официальном сайте АЧП создан! Комментарий: эта новость была создана на прошлом сайте АЧП.'
      ],
      links: []
    }
  ];

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  buyBook(link: string) {
    setTimeout(() => {
      window.open(link, '_blank');
    }, 300);
  }

}
